module.exports = __webpack_public_path__ + "static/media/veniaperez.e227fa29.png";